import React, { useState } from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";



const SUBJECTS = [
  "General Inquiry",
  "Order Status",
  "Product Information",
  "Returns & Exchanges",
  "Shipping & Delivery",
  "Account & Login",
  "Technical Support",
  "Corporate / Wholesale",
  "Press & Media",
  "Other",
];

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.subject) newErrors.subject = "Please select a subject";
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      const firstErrorField = Object.keys(formErrors)[0];
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
    }
  };

  return (
    <div className="contact">
      <Header />

      <main className="contact__main" id="MainContent" role="main">
        <div className="contact__content">
          <h1 className="contact__page-title">Contact Us</h1>

          <div className="contact__layout">
            {/* Left: form */}
            <section className="contact__form-section" aria-label="Contact form">
              <form
                className="contact__form"
                onSubmit={handleSubmit}
                noValidate
              >
                <div className="contact__row">
                  <div className="contact__field">
                    <label className="contact__label" htmlFor="firstName">
                      First Name <span className="contact__required">*</span>
                    </label>
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      className={`contact__input${errors.firstName ? " contact__input--error" : ""}`}
                      value={formData.firstName}
                      onChange={handleInputChange}
                      autoComplete="given-name"
                    />
                    {errors.firstName && (
                      <span className="contact__error" role="alert">
                        {errors.firstName}
                      </span>
                    )}
                  </div>

                  <div className="contact__field">
                    <label className="contact__label" htmlFor="lastName">
                      Last Name <span className="contact__required">*</span>
                    </label>
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      className={`contact__input${errors.lastName ? " contact__input--error" : ""}`}
                      value={formData.lastName}
                      onChange={handleInputChange}
                      autoComplete="family-name"
                    />
                    {errors.lastName && (
                      <span className="contact__error" role="alert">
                        {errors.lastName}
                      </span>
                    )}
                  </div>
                </div>

                <div className="contact__field">
                  <label className="contact__label" htmlFor="email">
                    Email Address <span className="contact__required">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className={`contact__input${errors.email ? " contact__input--error" : ""}`}
                    value={formData.email}
                    onChange={handleInputChange}
                    autoComplete="email"
                  />
                  {errors.email && (
                    <span className="contact__error" role="alert">
                      {errors.email}
                    </span>
                  )}
                </div>

                <div className="contact__field">
                  <label className="contact__label" htmlFor="phone">
                    Phone Number
                  </label>
                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    className="contact__input"
                    value={formData.phone}
                    onChange={handleInputChange}
                    autoComplete="tel"
                  />
                </div>

                <div className="contact__field">
                  <label className="contact__label" htmlFor="subject">
                    Subject <span className="contact__required">*</span>
                  </label>
                  <div className="contact__select-wrapper">
                    <select
                      id="subject"
                      name="subject"
                      className={`contact__select${errors.subject ? " contact__input--error" : ""}`}
                      value={formData.subject}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>
                        Select a subject
                      </option>
                      {SUBJECTS.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                    <span className="contact__select-arrow" aria-hidden="true">
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                        <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </div>
                  {errors.subject && (
                    <span className="contact__error" role="alert">
                      {errors.subject}
                    </span>
                  )}
                </div>

                <div className="contact__field">
                  <label className="contact__label" htmlFor="message">
                    Message <span className="contact__required">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    className={`contact__textarea${errors.message ? " contact__input--error" : ""}`}
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                  {errors.message && (
                    <span className="contact__error" role="alert">
                      {errors.message}
                    </span>
                  )}
                </div>

                <button type="submit" className="contact__submit">
                  Send Message
                </button>
              </form>
            </section>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;
